export const ITEM_TAG_OPTIONS = [
  { key: 'NUTS', label: 'Nuts', value: 'NUTS', active: true },
  { key: 'DAIRY', label: 'Dairy', value: 'DAIRY', active: true },
  { key: 'SHELLFISH', label: 'Shellfish', value: 'SHELLFISH', active: true },
  { key: 'RED_MEAT', label: 'Red Meat', value: 'RED_MEAT', active: true },
  { key: 'GLUTEN', label: 'Gluten', value: 'GLUTEN', active: true },
  { key: 'EGG', label: 'Egg', value: 'EGG', active: true },
  { key: 'SOY', label: 'Soy', value: 'SOY', active: true },
  { key: 'PORK', label: 'Pork', value: 'PORK', active: true }
];

export const ITEM_TAG_LABELS = ITEM_TAG_OPTIONS.reduce((acc, { value, label }) => {
  acc[value] = label;
  return acc;
}, {});
